import { schema as objectiveTypeBaseFixedRate } from './ObjectiveTypeBaseFixedRate.schema';
import { schema as objectiveTypeBaseVariableRate } from './ObjectiveTypeBaseVariableRate.schema';
import { schema as objectiveTypeBaseFixedAndVariableRate } from './ObjectiveTypeBaseFixedAndVariableRate.schema';
import { labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    fixed: objectiveTypeBaseFixedRate(Joi, labeled(label, 'Fixed -')),
    variable: objectiveTypeBaseVariableRate(Joi, labeled(label, 'Variable -')),
    fixedAndVariable: objectiveTypeBaseFixedAndVariableRate(
      Joi,
      labeled(label, 'Fixed And Variable -')
    )
  });

export default {
  schema
};
